module.exports = __webpack_public_path__ + "img/policyInfo.394a6ec4.png";